export const isInternalUrl = (url: string | null | undefined) => {
  return (url ?? '').charAt(0) === '/';
};
export const isHashUrl = (url: string | null | undefined) => {
  return (url ?? '').charAt(0) === '#';
};
